import axiosInstance from '../axiosInterceptor/axiosInstance'

const createStage = async ({ orgId, data }) => {
  const url = `v1/orgs/${orgId}/stages`
  const response = await axiosInstance.post(url, JSON.stringify(data))
  return response?.data
}

export default createStage
